module.exports = __webpack_public_path__ + "img/add4e66e94f006bb4cd9193e9c9f83bc.png";